<template>
  <div class="md-layout dashboard">

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 reportes" 
    v-show="user.roles[0] && user.roles[0].name =='Administrator'">
      <stats-card header-color="blue" :class="card_reporting" >
        <template slot="header" style="background: linear-gradient(60deg, #3c61ac, #35a1f4)">
          <div class="card-icon">
            <md-icon>calendar_today</md-icon>
          </div>
          <p class="category">{{first_report_text}}</p>
          <h3 class="title" style="font-weight: bold;">
            {{ primary_report_data }}
          </h3>
        </template>
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 reportes" 
    v-show="user.roles[0] && user.roles[0].name =='Administrator'">
      <stats-card header-color="blue" :class="card_reporting">
        <template slot="header" >
          <div class="card-icon">
            <md-icon>schedule</md-icon>
          </div>
          <p class="category">{{second_report_text}}</p>
          <h3 class="title" style="font-weight: bold;">
            {{ secondary_report_data }}
          </h3>
        </template>
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 mt-6">
      <md-card style="box-shadow:none">
      <md-card-header class="header-dashboard md-card-header-icon md-card-header-primary">
        <div>
        <div class="card-icon icono-azul">
          <md-icon>domain_verification</md-icon>
        </div>
        <h2 class="title titulo-icono">
          Calendar
        </h2>
        </div>
        <div>
          <md-button class="md-info md-dense md-size-100 boton-filtro" @click="changeShowFilters()" >
              <md-icon>filter_list</md-icon>
              Filters
          </md-button>
          <md-button :class="comments_filter_button" 
          style="align-self:center;margin-top:16px;margin-left:auto;float:right;margin-right:3px" 
          @click="changeWithComments()" v-if="user.roles[0] && user.roles[0].name =='Administrator'">
            <md-icon>mark_chat_read</md-icon>
            Commented</md-button>
          <md-button :class="report_button" 
          style="align-self:center;margin-top:16px;margin-left:auto;float:right;margin-right:3px" 
          @click="changeReportActive()">
            <md-icon>calculate</md-icon>
            Report
          </md-button>
        </div>
      </md-card-header>
      <transition name="slide" >
        <div class="md-card-content md-layout-item md-size-100 filters-calendar" style="margin-left:auto" v-show="mostrarFiltros">
          <md-datepicker v-model="start_date" class=" md-layout-item md-size-25 md-medium-size-25 md-small-size-100" 
          style="float:left;">
            <label style="margin-left: 10px;">Start Date</label>
          </md-datepicker>
          <md-datepicker v-model="finish_date" class=" md-layout-item md-size-25 md-medium-size-25 md-small-size-100" 
          style="float:left;">
            <label style="margin-left: 10px;">End Date</label>
          </md-datepicker>
        
          <md-field class="md-layout-item md-size-25 md-medium-size-25 md-small-size-100" style="float:left"
          v-if="!((user.roles[0] && user.roles[0].name =='Student'))">
            <md-icon>school</md-icon>
            <label for="movies" style="margin-left: 10px;">
              Student</label>
            <md-select v-model="selectedStudent" name="movies" id="movies" multiple>
              <md-option 
                v-for="item in students" v-bind:key="item.id"
                :value="item.id"> 
                {{item.nombre}} 
              </md-option>
            </md-select>
          </md-field>

          <md-field class="md-layout-item md-size-25 md-medium-size-25 md-small-size-100" style="float:left" 
          v-if="!((user.roles[0] && user.roles[0].name =='Student') ||  (user.roles[0] &&user.roles[0].name =='Teacher'))">
            <md-icon>supervised_user_circle</md-icon>
            <label for="teacher" style="margin-left: 10px;">
              Teacher</label>
            <md-select v-model="selectedTeacher" name="teacher" id="teacher" multiple>
              <md-option 
                v-for="item in teachers" v-bind:key="item.id"
                :value="item.id"> 
                {{item.nombre}} 
              </md-option>
            </md-select>
          </md-field>

        </div>
      </transition>
      <md-card-content>
        <div class="cuerpo-calendario">
          <kalendar :configuration="calendar_settings" :events="events" :key="kalendarKey">
            <!-- CREATED CARD SLOT -->
            <div slot="created-card"
                slot-scope="{ event_information }"
                class="details-card"
                @click="onShowEditEvent(event_information)">
              <h6 class="appointment-title">{{event_information.data.name}}</h6>
              <div class="info_inferior">
                <div class="info_horas">
                  <span class="time">{{event_information.start_time | formatToHours}} - {{event_information.end_time |
                    formatToHours}}</span>
                </div>
              </div>
            </div>
              <!-- CREATING CARD SLOT -->
              <div slot="creating-card" slot-scope="{ event_information }">
                <h6 class="appointment-title" style="text-align: left;">
                  New Lesson
                </h6>
                <span class="time">
                  {{event_information.start_time | formatToHours}}
                  -
                  {{event_information.end_time | formatToHours}}
                </span>
              </div>


              <!-- POPUP CARD SLOT -->
              <div slot="popup-form" slot-scope="{ popup_information }" style="display: flex; flex-direction: column;">
                <h4 style="margin-bottom: 10px">
                  New Lesson
                </h4>
                <div class="md-layout">
                  <md-field class="md-layout-item md-size-100 md-invalid">
                    <label>
                      Name
                    </label>
                    <md-input v-model="new_lesson.name" style="padding-top: 0px;" />
                    <validation-error :errors="apiValidationErrors.name" />
                  </md-field>
                  <md-field class="md-layout-item md-size-100">
                    <label>Student</label>
                    <md-select v-model="new_lesson.selectedStudent" id="students_selected">
                      <md-option 
                        v-for="item in students" v-bind:key="item.id"
                        :value="item.id"> 
                        {{item.nombre}} 
                      </md-option>
                    </md-select>
                  </md-field>
                  <validation-error :errors="apiValidationErrors.student_id" />
                  <md-field class="md-layout-item md-size-100" >
                    <label>Teacher</label>
                    <md-select v-model="new_lesson.selectedTeacher" id="teachers_selected">
                      <md-option 
                        v-for="item in teachers" v-bind:key="item.id"
                        :value="item.id"> 
                        {{item.nombre}} 
                      </md-option>
                    </md-select>
                  </md-field>
                  <validation-error :errors="apiValidationErrors.teacher_id" />
                  <md-field>
                    <label>Comments</label>
                    <md-textarea v-model="new_lesson.comment"></md-textarea>
                  </md-field>
                  <validation-error :errors="apiValidationErrors.comment" />
                  <div class="buttons">
                    <md-button class="cancel md-dense" @click="onCloseAddEvent()">
                        Cancel
                    </md-button>
                    <md-button @click="onAddEvent(popup_information)" class="md-info md-dense">
                      Save
                    </md-button>

                  </div>
                </div>
              </div>
          </kalendar>


          <!-- MODIFICATION CARD -->
          <div class="modification-card" v-if="activeModification">
                <h4 style="margin-bottom: 10px">
                  Edit Lesson
                </h4>
                <div class="md-layout">
                  <md-field class="md-layout-item md-size-100 md-invalid">
                    <label>
                      Name
                    </label>
                    <md-input v-model="card_selected.data.name" style="padding-top: 0px;" />
                    <validation-error :errors="apiValidationErrors.name" />
                  </md-field>
                  <md-field class="md-layout-item md-size-100">
                    <label>Student</label>
                    <md-select v-model="card_selected.data.student_id" id="students_selected" 
                    :disabled="this.user.roles[0].name =='Teacher'">
                      <md-option 
                        v-for="item in students" v-bind:key="item.id"
                        :value="item.id"> 
                        {{item.nombre}} 
                      </md-option>
                    </md-select>
                  </md-field>
                  <validation-error :errors="apiValidationErrors.student_id" />
                  <md-field class="md-layout-item md-size-100" >
                    <label>Teacher</label>
                    <md-select v-model="card_selected.data.teacher_id" id="teachers_selected" 
                    :disabled="this.user.roles[0].name =='Teacher'">
                      <md-option 
                        v-for="item in teachers" v-bind:key="item.id"
                        :value="item.id"> 
                        {{item.nombre}} 
                      </md-option>
                    </md-select>
                  </md-field>
                  <validation-error :errors="apiValidationErrors.teacher_id" />
                  <md-field class="md-layout-item md-size-50" >
                    <vue-timepicker :minute-interval="5" v-model="card_selected.data.start_date" 
                    :disabled="this.user.roles[0].name =='Teacher'"></vue-timepicker>
                  </md-field>
                  <md-field class="md-layout-item md-size-50" >
                    <vue-timepicker :minute-interval="5" v-model="card_selected.data.finish_date" 
                    :disabled="this.user.roles[0].name =='Teacher'"></vue-timepicker>
                  </md-field>
                  <md-field>
                    <label>Comments</label>
                    <md-textarea v-model="card_selected.data.comment"></md-textarea>
                  </md-field>
                  <validation-error :errors="apiValidationErrors.comment" />
                  <div class="buttons">
                    <md-button class="md-danger md-dense" style="margin-right:auto;" 
                    @click="onDeleteEditEvent(card_selected)" :disabled="this.user.roles[0].name =='Teacher'">
                      Delete
                    </md-button>
                    <md-button class="cancel md-dense" @click="onCancelEditEvent(card_selected)">
                      Cancel
                    </md-button>
                    <md-button @click="onEditEvent()" class="md-info pull-right md-dense">
                      Save
                    </md-button>
                  </div>
                </div>
            </div>
        </div>
      </md-card-content>
      </md-card>
    </div>

    <!-- INICIO DE REPORTES -->
    <div class="report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 mt-6" v-if="reportActive">
        <md-card style="box-shadow:none">
          <md-card-header class="md-card-header-icon md-card-header-primary" 
          style="display:flex;align-items: center;justify-content: space-between;">
            <div>
            <div class="card-icon icono-azul">
              <md-icon>domain_verification</md-icon>
            </div>
            <h2 class="title titulo-icono">
              Report
            </h2>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="cuerpo-reporte">
              <div style="display:flex;flex-direction:column">
                <div v-for="(evento,index) in this.events" :key="evento.id">
                  <div v-if="evento.separar" class="separador-evento">&nbsp;</div>
                  <div class="fecha-clase">
                    <div class="dato-fecha" style="flex:.2"> 
                      <span v-if="evento.separar || index==0">{{ evento.from | formatDate }}</span>
                    </div>
                    <div class="dato-hora" style="flex:.4">
                      {{ evento.from | formatToHours }} - {{ evento.to | formatToHours }}
                    </div>
                    <div class="dato-clase" style="flex:1">
                      <b>{{ evento.data.name }}</b>&nbsp;{{ evento.comment }}
                    </div>
                  </div>
                </div>
                <div class="separador-evento">&nbsp;</div>
                <div class="fecha-clase">
                  <div class="dato-fecha" style="flex:.6"> 
                    Total Classes <br/>
                  </div>
                  <div class="dato-clase" style="flex:1">
                    <b>{{ primary_report_data }}</b>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <!-- FIN DE REPORTES -->

  </div>
</template>

<script>

import { StatsCard } from "@/components";
import { Kalendar } from '../../components/Kalendar';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

const CLASE_EN_MILISEGUNDOS = 3000000;

export default {
  components: {
    StatsCard,
    Kalendar,
    ValidationError,
    VueTimepicker
  },

  mixins: [formMixin],

  computed:{
    clase_en_minutos : function (){
      return CLASE_EN_MILISEGUNDOS / 1000 /60;
    },
    primary_report_data:function(){
      if(this.reportActive)
      {
        let diff = 0;
        let fechaEventoAnterior = null;
        let fechaEvento = null;
        this.events.forEach((event,index) => {
          diff += new Date(event.finish_date) - new Date(event.start_date);
          if(this.events[index-1]){
            fechaEventoAnterior = new Date(this.events[index-1].from)
            fechaEventoAnterior.setHours(0, 0, 0, 0);
            fechaEvento = new Date(this.events[index].from)
            fechaEvento.setHours(0, 0, 0, 0) 
            if(fechaEvento.getTime() !== fechaEventoAnterior.getTime()){
              this.events[index].separar= true;
            }
          }
        });
        let hours =  Math.round((diff % 86400000) /  CLASE_EN_MILISEGUNDOS*10)/10;
        return hours;
      }else{
        return this.countMonth;
      }
      
    },
    secondary_report_data:function(){
      if(this.reportActive)
      {
        return this.events.length;
      }else{
        return this.countWeek;
      }
    },
    comments_filter_button:function(){
        return{
        'md-simple': !this.withComments,
        'md-dense': true,
        'md-secondary': this.withComments,
        'md-size-100':true
      }
    },
    first_report_text: function(){
      return this.reportActive? "Classes" :"Classes during the Month";
    },
    second_report_text: function(){
      return this.reportActive? "Sessions" :"Classes during the Week";
    },
    report_button: function(){
        return{
          'md-simple': !this.reportActive,
          'md-warning': this.reportActive,
          'md-dense':true,
          'md-size-100':true
        }
    },
    card_reporting:function(){
      return{
        'card-superior': !this.reportActive,
        'card-superior-active': this.reportActive,
      }
    }
  },

  watch: {
    start_date(newDate, oldDate) {
      this.$kalendar.establecerCurrentTime(new Date(newDate).toISOString());
      setTimeout(() => {this.$kalendar.buildWeek();});
      if(!this.esPrimerDibujado){
        this.getListLessons()
      }
    },
    finish_date(newDate, oldDate){
      if(newDate < this.start_date){
        alert("Finish date cannot be less than the start date")
      }else{
        if(!this.esPrimerDibujado){
        this.getListLessons()
      }
      }
    },
    selectedStudent(newValue, OldValue){
      if(newValue.length>0){
        this.filtered_students = newValue.slice(1);        
      }else{
        this.filtered_students=[];
      }
      if(!this.esPrimerDibujado){
        this.getListLessons()
      }
    },
    selectedTeacher(newValue,OldValue){
      if(newValue.length>0){
        this.filtered_teachers = newValue.slice(1);        
      }else{
        this.filtered_teachers=[];
      }
      if(!this.esPrimerDibujado){
        this.getListLessons()
      }
    }
  },
  data() {
    let now_start = new Date()
    let now_finish = new Date()
    return {
      start_date: null,
      finish_date: null,
      teachers:[
        {
          id:"1",
          nombre: "Admin",
          email: "admin@jsonapi.com",
          created_at: "2020-01-01",
        }
      ],
      students:[
        {
          id:"2",
          nombre: "Admin",
          email: "admin@jsonapi.com",
          created_at: "2020-01-01",
        },
      ],
      countMonth:0,
      countWeek:0,
      reportActive: false,
      withComments: false,
      selectedStudent:"",
      selectedTeacher:"",
      kalendarKey:0,
      card_selected:{data:{}},
      filtered_students:[],
      filtered_teachers:[],
      events: [
        {
          from: '2022-12-12T18:00:00Z',
          to: '2022-12-12T19:00:00Z',
          data: 'Event 1',
        }
      ],
      activeModification:false,
      mostrarFiltros:false,
      selectedLabeled:"",
      new_lesson: {},
      esPrimerDibujado: true,
      habilitadoPicker: false,
      calendar_settings: {
        style: 'material_design',
        fill:"a9daff",
        cell_height: 10,
        read_only: false,
        day_starts_at: 6,
        day_ends_at: 23,
        current_day: new Date().toISOString(),
        overlap: true,
      },
      selected: [],
      user:{roles:[]}
    };
  },
  created() {
      this.getStudentsList();
      this.getTeachersList();
      this.getFirstDayOfWeek();
      this.getListLessons();
      this.$store.watch(() => this.$store.getters["lessons/list"], (list) => {
            this.events = list.map(function(lesson) {
              lesson = {...lesson,from:lesson.start_date,to:lesson.finish_date,data:lesson}
              return lesson;
            },this);
            this.$kalendar.updateEvents(this.events);
            this.kalendarKey += 1;
      })
  },
  mounted(){
    this.$store.watch(() => this.$store.getters["profile/me"], (me) => {
        this.user = me
        if(this.user.roles[0] && this.user.roles[0].name !='Administrator'){
          this.calendar_settings.read_only = true;
        }
      })
      this.$store.dispatch("profile/me")
  },

  methods: {
    
    compareDates(date1,date2){
      return this.$options.filters.yymmdd(date) === this.todayIs;
    },

    getListLessons() {
      this.$store.dispatch("lessons/list",
        {
        "student":this.filtered_students,
        "teacher":this.filtered_teachers,
        "with-comments":this.withComments ? true : null,
        "start-date":this.start_date,
        "finish-date":this.finish_date
      });


      this.$store.watch(() => this.$store.getters["lessons/doneMonth"], (count) => {
        this.countMonth = count;
      })
      this.$store.dispatch("lessons/countLessonMonth");


      this.$store.watch(() => this.$store.getters["lessons/doneWeek"], (count) => {
        this.countWeek = count;
      })
      this.$store.dispatch("lessons/countLessonWeek");
      
    },

    async onAddEvent(popup_data) {
      let lesson = {
          name: this.new_lesson.name,
          comment: this.new_lesson.comment,
          student_id: this.new_lesson.selectedStudent,
          teacher_id: this.new_lesson.selectedTeacher,
          start_date: popup_data.start_time,
          finish_date: popup_data.end_time,
      };

      let payload = {
        data:  {name:this.new_lesson.name,student_id: this.new_lesson.selectedStudent,teacher_id: this.new_lesson.selectedTeacher,start_date: popup_data.start_time,
          finish_date: popup_data.end_time},
        from: popup_data.start_time,
        to: popup_data.end_time,
      };
      
      try {
          let lesson_created = await this.$store.dispatch("lessons/add", lesson)
          payload.data.id = lesson_created.id;
          this.$kalendar.addNewEvent(
            payload,
          );
          await this.$store.dispatch("alerts/success", "New lesson created successfully.")
          this.$kalendar.onCloseAddEvent();
          this.clearFormData();
        } catch (e) {
          if(e.response){
            await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
            this.setApiValidation(e.response.data.errors)
          }
        }     
    },

    async onEditEvent() {  
      let lesson = {
          ...this.card_selected.data,
          student_id: this.card_selected.data.student_id,
          teacher_id: this.card_selected.data.teacher_id,
          start_date: this.card_selected.data.bk_start_date.slice(0, 10)+" "+this.card_selected.data.start_date+":00",
          finish_date: this.card_selected.data.bk_finish_date.slice(0, 10)+" "+this.card_selected.data.finish_date+":00"
      };   

      let day = lesson.start_date.slice(0, 10);
      this.$kalendar.removeEvent({
          day,
          key: this.card_selected.key,
          id: this.card_selected.kalendar_id,
      })

      let payload = {
        data:  {...this.card_selected.data,start_date:lesson.start_date,finish_date:lesson.finish_date},
        from: lesson.start_date,
        to: lesson.finish_date,
      };
       
      try {
        await this.$store.dispatch("lessons/update", lesson);
        await this.$store.dispatch(
          "alerts/success",
          "Lesson updated successfully."
        );
        //Actualizar la vista del calendario
        setTimeout(() => {this.$kalendar.buildWeek();});
        this.activeModification = false;
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }

      this.$kalendar.addNewEvent(
            payload,
          );
    },


    onCloseAddEvent: function(){
      this.$kalendar.closePopups();
    },
    

    async onDeleteEditEvent(information) {
        if(confirm("Do you really want to delete?")){
          let day = information.start_time.slice(0, 10);
          this.$kalendar.removeEvent({
            day,
            key: information.key,
            id: information.kalendar_id,
          })

          try {
            await this.$store.dispatch("lessons/destroy", information.data.id)
            await this.$store.dispatch("alerts/success", "Lesson Removed.")
          } catch (e) {
            if(e.response){
              await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
            }
          }     
          this.activeModification = false;
        }
    },

    onShowEditEvent: function(information){
      if(this.user.roles[0] && 
            (this.user.roles[0].name =='Administrator' ||
            this.user.roles[0].name == 'Teacher')){
        this.card_selected = information;
        this.card_selected.data.bk_start_date= this.card_selected.data.start_date;
        this.card_selected.data.bk_finish_date= this.card_selected.data.finish_date;
        this.activeModification = true;
      }
    },
    onCancelEditEvent : function(){
      this.activeModification = false;
    },
    changeShowFilters: function(value){
      this.mostrarFiltros = !this.mostrarFiltros;
      this.esPrimerDibujado = false;
    },
    changeWithComments: function(value){
      this.withComments = !this.withComments;
      this.getListLessons()
    },
    changeReportActive: function(value){
      this.reportActive= !this.reportActive;
      if(this.reportActive){
        this.scrollToReport({behavior: 'smooth',inline:'end',vertical:'end'});
      }
    },
    scrollToReport: function(options) {
      const el = this.$el.getElementsByClassName('report')[0];
      if (el) {
        el.scrollIntoView(options);
      }
    },
    getFirstDayOfWeek(d) {
      d = new Date();
      var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6:1);
      this.calendar_settings.start_day= new Date(d.setDate(diff)).toISOString();
      },
    getStudentsList() {
        this.$store.watch(() => this.$store.getters["users/students"], (list) => {
          this.students = list
        })
        this.$store.dispatch("users/students",{role:"Student"})
    },
    getTeachersList() {
        this.$store.watch(() => this.$store.getters["users/teachers"], (list) => {
          this.teachers = list
        })
        this.$store.dispatch("users/teachers",{role:"Teacher"})
    },
  }
};
</script>
